import React from 'react';
import { createPortal } from 'react-dom';
import { Button } from 'reactstrap';

export default (props) => {
  const buttonProps = { ...props };
  const target = document.getElementById(props.targetId);
  delete buttonProps.children;
  delete buttonProps.targetId;
  delete buttonProps.intl;
  if (target) {
    return (
      createPortal(
        <Button
          {...buttonProps}
        >
          {props.children}
        </Button>,
        target
      )
    );
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/components/PortalButton/PortalButton.jsx